import React, { useState, useCallback, useEffect } from 'react';
import EdgeOrREST from '../../EdgeOrREST';
import Notification from '../../components/shared/notification.component';
import {
  makeStyles,
  Button,
  TextField,
  Checkbox,
  Switch,
  Tooltip,
  FormControlLabel,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Paper,
  Tabs,
  Tab,
  Box,
  Radio,
  FormControl,
  Stepper,
  Step,
  StepLabel,
  RadioGroup,
  MenuItem,
  CircularProgress,
} from '@material-ui/core';
import { Autocomplete, Skeleton } from '@mui/material';
import TreeView from '@material-ui/lab/TreeView';
import TreeItem from '@material-ui/lab/TreeItem';
import Typography from '@material-ui/core/Typography';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import AddIcon from '@material-ui/icons/AddCircle';
import FolderIcon from '@material-ui/icons/Folder';
import DescriptionIcon from '@mui/icons-material/Description';
import EditIcon from '@material-ui/icons/Edit';
import ConfirmationDialog from '../confirmation-dialog.component';
import RemoveIcon from '@material-ui/icons/RemoveCircleOutline';
import { useDispatch, useSelector } from 'react-redux';
import user from '../../store/actions/user';
import PhotometricAttributeSelector from '../photometice-attributes-menu/photometric-attribute-selector.component';
import PhotometricAttributeStreetlightSelector from '../photometice-attributes-menu/photometric-attribute-streetlight-selector.component';
import luminaireActions from '../../store/actions/luminaireActions';
import PhotometricUpload from './photometric-upload.component';
import PhotometricMediaUpload from '../photometric-media-upload.component';
import tourActions from '../../store/actions/tourActions';
import Loading from '../../components/shared/loading.component';
import Group from './photometric-tree-groups.js';
import Luminaire from './photometric-tree-luminaire.js';

const useTreeItemStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    '&:hover > $content': {
      backgroundColor: theme.palette.action.hover,
    },
    '&:focus > $content, &$selected > $content': {
      backgroundColor: `tertiary, ${theme.palette.grey[400]})`,
      color: 'secondary',
    },
    '&:focus > $content $label, &:hover > $content $label, &$selected > $content $label': {
      backgroundColor: 'transparent',
    },
  },
  content: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '$expanded > &': {
      fontWeight: theme.typography.fontWeightRegular,
    },
  },
  group: {
    marginLeft: 0,
    '& $content': {
      paddingLeft: theme.spacing(2),
    },
  },
  expanded: {},
  selected: {},
  label: {
    color: 'inherit',
    marginRight: theme.spacing(1),
    fontSize: '20px'
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelIcon: {
    marginRight: theme.spacing(1),
  },
  labelText: {
    flexGrow: 1,
  },
  dialogPaper: {
    minWidth: '550px',
  }
}));

const useStyles = makeStyles((theme) => ({
  root: {
    height: 'auto',
    flexGrow: 1,
    width: '100%',
    maxHeight: '750px',
    overflowY: 'auto'
  },
  dialogPaper: {
    minWidth: '550px',
  },
  labelText: {
    flexGrow: 1,
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} style={{ padding: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function PhotometricTree(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [groupName, setGroupName] = React.useState("");
  const [groupDescription, setGroupDescription] = React.useState("");
  const [addGroupError, setAddGroupError] = React.useState(false);
  const [selectedToRemove, setSelectedToRemove] = React.useState([]);
  const [privateGroup, setPrivacy] = React.useState({
    checked: true
  });
  const state = useSelector(state => state);
  const [expanded, setExpanded] = React.useState([]);
  const [gotChildren, setGotChildren] = React.useState([]);
  const [parentGroupId, setParentGroupId] = React.useState(0);
  const [selectedNode, setSelectedNode] = React.useState(null);
  const [selectedGroup, setSelectedGroup] = React.useState(null);
  const [lowestGroups, setLowestGroups] = React.useState([]);
  const handleChange = (event) => {
    setPrivacy({ ...privateGroup, 'checked': event.target.checked });
  };
  const [snack, setSnack] = React.useState({
    open: false
  });
  const [open, setOpen] = React.useState(false);
  const [attributeParams, setAttributeParams] = React.useState({});
  const [addTap, setAddTap] = React.useState(0);
  const [sort, setSort] = React.useState(state.user.sortBy);
  const sortBy = [
    { value: 0, label: 'A-Z' },
    { value: 1, label: 'Z-A' },
    { value: 2, label: 'Created ↑' },
    { value: 3, label: 'Created ↓' }
  ];
  const [isAddingFolders, setIsAddingFolders] = React.useState(false);
  const [postArr, setPostArr] = React.useState([]);
  const [groupPathMap, setGroupPathMap] = React.useState({})
  const [canReset, setCanReset] = React.useState(true);
  const [processComplete, setProcessComplete] = useState(false);
  const [startTime, setStartTime] = useState(null);
  const [failedCount, setFailedCount] = useState(0);
  const [once, setOnce] = React.useState(false);
  const [processedCount, setProcessedCount] = useState(0);
  const [alertShown, setAlertShown] = useState(false);
  const [failedFiles, setFailedFiles] = useState([]);
  const [openRepeat, setOpenRepeat] = React.useState(false);
  const [counter, setCounter] = React.useState(10);
  const [loadingGroups, setLoadingGroups] = React.useState([]);
  const [progress, setProgress] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState("");
  const [isRefresh, setIsRefresh] = React.useState(false);
  const [groupFilter, setGroupFilter] = React.useState(new Map().set(0, ""))
  const [isSelecting, setIsSelecting] = useState(false);
  const [selectAction, setSelectAction] = useState(null);

  const createGroup = (event) => {
    if (groupName && groupName.length > 0 && !(groupName.trim() == "")) {
      var treeItem = {
        'parentId': parentGroupId,
        'lumminaireId': 0,
        'name': groupName,
        'description': groupDescription,
        'isPrivate': privateGroup.checked
      };
      EdgeOrREST(null, 'CREATE_GROUP', onCreateGroup, treeItem);
      console.log("attributeParams", attributeParams);
      setGroupName("");
      setGroupDescription("");
      if (!isAddingFolders) {
        setGroupName("");
      }
      setAddGroupError(false);
      setOpen(false);
    } else {
      setAddGroupError(true);
    }
    setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
  }

  const onCreateGroup = (response) => {
    console.log("onCreateGroup", response);
    EdgeOrREST(null, 'ADD_ATTRIBUTES_TO_GROUP', onAddAttributesToGroup, { attributeParams: attributeParams, id: response.data });
    getAllLowestChildrenFolders();
    if (parentGroupId <= 0) {
      handleRefreshTree();
    } else {
      EdgeOrREST(null, 'GET_TREE_CHILDREN', onGetChildren, { headers: { 'id': parentGroupId } });
    }
  };

  const onAddAttributesToGroup = (response) => {

  };

  const onChangeGroup = (response) => {
    console.log("force onchange group");
    props.forceUpdate();
  };

  // const onSelectLuminaire = (event) => {
  //   console.log("onSelectLuminaire", event);
  //   if (event.selected) {
  //     const selectedLuminaires = selectedToRemove.slice();
  //     selectedLuminaires.push(event);
  //     setSelectedToRemove(selectedLuminaires);
  //   } else {
  //     var lumCopy = selectedToRemove;
  //     if (selectedToRemove) {
  //       var removeIndex = selectedToRemove.map(lum => lum.id).indexOf(event.id);
  //       removeIndex && lumCopy.splice(removeIndex, 1);
  //       setSelectedToRemove(lumCopy);
  //     }
  //   }
  // };

  const onRemoveConfirm = (event) => {
    console.log("onRemoveConfirm", selectedToRemove);
    if (selectedToRemove.length > 0) {
      setLoadingGroups(true);
      EdgeOrREST(null, 'REMOVE_LUMINAIRES_FROM_TREE', onDeleteGroupOrGroupItem, selectedToRemove);
    }
  }

  const onDeleteGroupOrGroupItem = (response) => {
    if (response.status == 200) {
      setSnack({
        open: true,
        message: "Group or Luminaire(s) removed successfully.",
        severity: 'success'
      });
    } else {
      setSnack({
        open: true,
        message: response.status + response.message,
        severity: 'error'
      });
    }
    resetGotChildren();
    setLoadingGroups(false);
    console.log("force ondelete group");
    props.forceUpdate();
  };

  const handleClose = () => {
    setSnack({
      ...snack,
      open: false
    });
  };

  function checkForAdminPriv() {
    var isAdmin = false;
    var checkbox = [];
    if (state.user.roles) {
      for (var i = 0; i < state.user.roles.length; i++) {
        if (state.user.roles[i].name === "admin") {
          isAdmin = true;
        }
      }
    }
    return checkbox;
  }

  const handleNodeToggle = async (event, nodeIds) => {
    console.log("handleNodeToggle", nodeIds);
    const expandedNodes = nodeIds.filter((nodeId) => !expanded.includes(nodeId));
    if (expandedNodes.length > 0) {
      handleExpand(expandedNodes[0]);
    }
    setExpanded(nodeIds);
  };

  const handleExpand = (nodeId) => {
    setGotChildren((prev) => {
      if (!prev.includes(nodeId)) {
        handleOpenGroup(nodeId);
        console.log("handleExpand", nodeId);
        EdgeOrREST(null, 'GET_TREE_CHILDREN', onGetChildren, { headers: { 'id': nodeId } });
        return [...prev, nodeId];
      }
      return prev;
    });
  };

  const handleOpenGroup = (groupId) => {
    console.log("handleOpenGroup", groupId);
    setLoadingGroups((prevLoadingGroups) => ({
      ...prevLoadingGroups,
      [groupId]: true,
    }));

    setTimeout(() => {
      setLoadingGroups((prevLoadingGroups) => ({
        ...prevLoadingGroups,
        [groupId]: false,
      }));
    }, 750);
  };

  const onGetChildren = (response) => {
    const wholeGroup = props.groups;
    console.log("Whole group onGetChildren:", wholeGroup);

    if (response.data != null && response.data.length > 0 && wholeGroup != null && wholeGroup.length > 0) {
      const parentId = response.data[0].parentId;
      const updatedKey = response.data[0].luminaireId === 0 ? 'groups' : 'luminaires';

      const oldItem = wholeGroup.find(g => g.id === parentId);

      // console.group("Updating group item");
      // console.log("Parent ID:", parentId);
      // console.log("Old item:", oldItem);
      console.log("Incoming data:", response.data);
      // console.log("Target key:", updatedKey);
      // console.groupEnd();

      const updatedGroups = updateGroup(parentId, wholeGroup, response.data, updatedKey);
      console.log("Updated groups after onGetChildren:", updatedGroups);
      dispatch(user.UpdateUserCfg({ groups: updatedGroups }));
      console.log("Updated groups onGetChildren:", updatedGroups);
    }
  };

  const updateGroup = (parentId, wholeGroup, updatedGroup, type) => {
    console.group("updateGroup");
    console.log("Updating group ID:", parentId);
    console.log("New data:", updatedGroup);
    console.log("Key to update:", type);
    console.groupEnd();

    const update = groups => {
      return groups.map(group => {
        if (group.id === parentId) {
          group[type] = updatedGroup;
          return group;
        } else if (group.groups) {
          return {
            ...group,
            groups: update(group.groups)
          };
        } else {
          return group;
        }
      });
    };
    return update(wholeGroup);
  };

  function resetGotChildren() {
    console.log("resetGotChildren");
    setExpanded([]);
    setGotChildren([]);
    getAllLowestChildrenFolders();
  }

  useEffect(() => {
    resetGotChildren();
  }, [])

  useEffect(() => {
    console.log("state?.LuminaireCfg", state.LuminaireCfg);
    if (state?.LuminaireCfg?.selectedLuminaireIds[0] && state?.LuminaireCfg?.selectedLuminaireIds[0] != selectedNode) {
      EdgeOrREST(null, 'GET_ALL_FOLDER_PARENT', onGetParent, { headers: { 'id': state.LuminaireCfg.selectedLuminaireIds[0] } });
      setSelectedNode(state.LuminaireCfg.selectedLuminaireIds[0]);
    }
  }, [state?.LuminaireCfg.selectedLuminaireIds]);

  const onGetParent = (response) => {
    console.log("onGetParent", response);

    if (response.data?.length > 0) {
      const parentIds = [];
      setSelectedGroup(response.data[0]);
      // resetGotChildren();

      response.data.reverse().forEach(({ id }, index) => {
        setTimeout(() => {
          handleExpand(id);
        }, index * 500); // wait 0.1 second between each data
        parentIds.push(id);
      });
      setExpanded(parentIds);
    }
  };

  const handleOpen = (currentId) => {
    if (state.EnabledTour.helpMode) {
      dispatch(tourActions.UpdateHelpURL({ helpURL: "Add Groups" }))
      const video = document.getElementById("help-video")
      video.load();
      dispatch(tourActions.UpdateHelpText({ helpText: "This button lets you create new groups." }))
    } else {
      setIsAddingFolders(false);
      setParentGroupId(currentId);
      setOpen(true);
      setTimeout(() => { dispatch(tourActions.UpdateCurrentStep({ currentStep: state.EnabledTour.currentStep + 1 })) }, 50);
    }
  }

  const startDirectoryProcessing = () => {
    setIsLoading("folders");
    setSnack({
      open: true,
      message: "Process has started.",
      severity: 'info'
    });
    setStartTime(new Date());
    setAlertShown(false);
  };

  const collectFolderPathsFromDirectoryHandle = async (directoryHandle, currentPath = directoryHandle.name) => {
    const folderPaths = [];

    for await (const handle of directoryHandle.values()) {
      if (handle.kind === 'directory') {
        const folderPath = `${currentPath}/${handle.name}`;
        folderPaths.push(folderPath);
        const childPaths = await collectFolderPathsFromDirectoryHandle(handle, folderPath);
        folderPaths.push(...childPaths);
      }
    }

    return folderPaths;
  };

  const handleFolderOnlyUpload = async () => {
    if (!window.showDirectoryPicker) {
      document.getElementById('directory-input')?.click();
      return;
    }

    try {
      const directoryHandle = await window.showDirectoryPicker();
      startDirectoryProcessing();
      setPostArr([]);

      const folderPaths = await collectFolderPathsFromDirectoryHandle(directoryHandle);
      handleGroupNames(folderPaths.sort(), directoryHandle.name, false, []);
    } catch (error) {
      setIsLoading("");
      if (error?.name !== 'AbortError') {
        const fallbackInput = document.getElementById('directory-input');
        if (fallbackInput) {
          fallbackInput.click();
          return;
        }

        setSnack({
          open: true,
          message: "Unable to read the selected folder.",
          severity: 'error'
        });
      }
    }
  };

  function DirectoryInput() {
    const handleDirectoryChange = async (addingFiles, event) => {
      event.preventDefault();
      startDirectoryProcessing();

      const files = event.target.files;
      const hasSubfolders = new Set();
      const allowedExtensions = ['.ldt', '.ies'];
      const nextPostArr = [];

      if (files.length === 0) {
        setIsLoading("");
        setSnack({
          open: true,
          message: addingFiles
            ? "No photometric files (.ldt or .ies) were found in the selected folder."
            : "No folders could be imported from the selected directory.",
          severity: 'warning'
        });
        event.target.value = null;
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const filePath = files[i].webkitRelativePath;
        const parentLevel = filePath.substring(0, filePath.lastIndexOf("/"));
        const bottomLevel = parentLevel.substring(0, parentLevel.lastIndexOf("/"));

        hasSubfolders.add(bottomLevel);
      }

      if (addingFiles) {
        for (let i = 0; i < files.length; i++) {
          const filePath = files[i].webkitRelativePath;
          const file = files[i];
          const parentLevel = filePath.substring(0, filePath.lastIndexOf("/"));
          const fileExtension = filePath.split('.').pop().toLowerCase();
          // console.log("fileExtension",fileExtension)

          if (!hasSubfolders.has(parentLevel) && allowedExtensions.includes(`.${fileExtension}`)) {
            const base64 = await convertToBase64(file);

            nextPostArr.push({
              'file': base64,
              'filePath': parentLevel,
              'type': fileExtension,
              'name': filePath.split("/").pop(),
              'isPublic': false,
              'attributes': { manufacturer: "any", ...attributeParams }
            });
          }
        }
      }

      if (addingFiles && nextPostArr.length === 0) {
        setIsLoading("");
        setSnack({
          open: true,
          message: "No photometric files (.ldt or .ies) were found in the selected folder.",
          severity: 'warning'
        });
        event.target.value = null;
        return;
      }

      setPostArr(nextPostArr);

      if (files.length > 0) {
        const folderFullPathArray = [];
        for (let i = 0; i < files.length; i++) {
          const filePath = files[i].webkitRelativePath;
          const folderNames = filePath.split("/");
          let currentLevel = 1;
          let currentFolder = folderNames[0];
          let currentFullPath = currentFolder;

          for (let j = 0; j < folderNames.length - 1 && currentLevel < folderNames.length - 1; j++) {
            currentFolder = currentFolder + "/" + folderNames[currentLevel];
            currentFullPath += "/" + folderNames[currentLevel];
            if (folderFullPathArray.indexOf(currentFullPath) === -1) {
              folderFullPathArray.push(currentFullPath);
            }
            currentLevel++;
          }
        }
        folderFullPathArray.sort();
        handleGroupNames(folderFullPathArray, files[0].webkitRelativePath.split("/")[0], addingFiles, nextPostArr);
      }

      event.target.value = null;
    };

    return (
      <div>
        <input
          type="file"
          directory="" webkitdirectory="" mozdirectory=""
          onChange={(event) => handleDirectoryChange(true, event)}
          style={{ display: 'none' }}
          id="directory-files-input"
        />
        <label htmlFor="directory-files-input">
          <Button variant="text" color="inherit" component="span" onMouseEnter={() => handleResetArr()} onMouseLeave={() => setCanReset(false)}>
            <AddIcon style={{ fontSize: '15pt' }} />
            <Typography variant="body2" className={classes.labelText}>
              {"Add Folders and Files"}
            </Typography>
          </Button>
        </label>

        <input
          type="file"
          directory="" webkitdirectory="" mozdirectory=""
          onChange={(event) => handleDirectoryChange(false, event)}
          style={{ display: 'none' }}
          id="directory-input"
        />
        <Button variant="text" color="inherit" component="span" onClick={handleFolderOnlyUpload}>
          <AddIcon style={{ fontSize: '15pt' }} />
          <Typography variant="body2" className={classes.labelText}>
            {"Add Folders"}
          </Typography>
        </Button>
      </div>
    );
  }

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(';base64,').pop(); // Remove prefix
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const handleGroupNames = (folderNameArray, rootPath, addingFiles, pendingFiles = []) => {
    setIsAddingFolders(true);
    setGroupPathMap({});
    resetGotChildren();

    console.log("force recursive group group");
    props.forceUpdate();

    var treeItem = {
      'parentId': 0,
      'lumminaireId': 0,
      'name': rootPath,
      'description': groupDescription,
      'isPrivate': true
    };

    handleRecursiveGroupCreation(0, folderNameArray, rootPath, treeItem, {}, addingFiles, pendingFiles);

    setAddGroupError(false);
  };

  const completeFolderCreation = (pathMap, addingFiles, pendingFiles) => {
    setGroupPathMap(pathMap);
    setIsAddingFolders(false);

    if (addingFiles && pendingFiles.length > 0) {
      setProcessedCount(0);
      setFailedCount(0);
      setFailedFiles([]);
      handleFiles(pathMap, pendingFiles);
      return;
    }

    setIsLoading("");
    setSnack({
      open: true,
      message: addingFiles ? "Folder has been added." : "Folders have been added.",
      severity: 'success'
    });
    resetGotChildren();
  };

  const handleRecursiveGroupCreation = (count, folderArray, rootPath, initialTreeItem, localPathMap, addingFiles, pendingFiles) => {
    if (count === 0) {
      EdgeOrREST(null, 'CREATE_GROUP', (response) => {
        const nextPathMap = { ...localPathMap, [rootPath]: response.data };
        if (folderArray.length === 0) {
          completeFolderCreation(nextPathMap, addingFiles, pendingFiles);
          return;
        }

        handleRecursiveGroupCreation(count + 1, folderArray, rootPath, initialTreeItem, nextPathMap, addingFiles, pendingFiles);
      }, initialTreeItem);
      return;
    }

    const newGroup = folderArray[count - 1];
    if (!newGroup) {
      completeFolderCreation(localPathMap, addingFiles, pendingFiles);
      return;
    }

    const newGroupName = newGroup.split("/").pop();
    const parentFullPath = newGroup.substring(0, newGroup.lastIndexOf("/"));
    const parentId = localPathMap[parentFullPath];

    var treeItem = {
      'parentId': parentId,
      'lumminaireId': 0,
      'name': newGroupName,
      'description': groupDescription,
      'isPrivate': true
    };

    EdgeOrREST(null, 'CREATE_GROUP', (response) => {
      const nextPathMap = { ...localPathMap, [newGroup]: response.data };

      if (count >= folderArray.length) {
        completeFolderCreation(nextPathMap, addingFiles, pendingFiles);
        return;
      }

      handleRecursiveGroupCreation(count + 1, folderArray, rootPath, initialTreeItem, nextPathMap, addingFiles, pendingFiles);
    }, treeItem);
  };

  const handleFiles = async (pathMap = groupPathMap, queuedFiles = postArr) => {
    setIsLoading("files");
    const batchSize = 200; // Number of files to upload per batch

    const currentFiles = [...queuedFiles];
    let localProcessed = 0;
    let remainingFiles = currentFiles;

    while (localProcessed < (batchSize * 10) && remainingFiles.length > 0) {
      const batchFiles = remainingFiles.slice(0, batchSize);

      await uploadBatch(batchFiles, pathMap);

      localProcessed += batchFiles.length;
      remainingFiles = remainingFiles.slice(batchFiles.length);
    }

    setPostArr(remainingFiles);

    if (remainingFiles.length > 0) {
      setCounter(10);
      setOpenRepeat(true);
      setProgress(prevProgress => prevProgress + (localProcessed / currentFiles.length) * 100);
    } else {
      setProcessComplete(true);
      setIsLoading("");
      setCanReset(true);
    }
  };

  function handleRepeatUpload() {
    setOpenRepeat(false)
    handleFiles();
  }

  const uploadBatch = async (batchFiles, pathMap = groupPathMap) => {
    const uploadPromises = batchFiles.map(async (file) => {
      const targetGroupId = pathMap[file.filePath];

      if (!targetGroupId) {
        setFailedCount(prevFailedCount => prevFailedCount + 1);
        setFailedFiles(prevFailedFiles => [...prevFailedFiles, file.name]);
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        EdgeOrREST(null, 'UPLOAD_LUMINAIRES_AND_ADD_GROUP', (response) => {
          if (response.data.failed) {
            setFailedCount(prevFailedCount => prevFailedCount + 1);
            setFailedFiles(prevFailedFiles => [...prevFailedFiles, file.name]);
          } else {
            setProcessedCount(prevProcessedCount => prevProcessedCount + 1);
          }
          resolve();
        }, { groupId: targetGroupId, addLuminaire: [file] });
      });
    });

    await Promise.all(uploadPromises);
  };

  useEffect(() => {
    if (processComplete && !alertShown) {
      const endTime = new Date();
      const durationSeconds = (endTime - startTime) / 1000; // Duration in seconds
      const minutes = Math.floor(durationSeconds / 60);
      const seconds = Math.floor(durationSeconds % 60);
      const duration = minutes > 0 ? `${minutes} minute(s) ${seconds} second(s)` : `${seconds} second(s)`;
      window.alert(`Process is finished. It took ${duration}. ${processedCount} files were successful. ${failedFiles.length > 0 ? `${failedFiles.length} files failed to import.` : 'No files failed'}`);
      setProcessComplete(false);
      setFailedCount(0);
      setAlertShown(true);
    }
  }, [processComplete]);

  React.useEffect(() => {
    if (openRepeat) {
      if (counter === 0) {
        handleRepeatUpload();
      }
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, openRepeat]);

  const handleResetArr = () => {
    if (canReset) {
      setPostArr([])
    }
  }

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleAttributeParams = useCallback((attributeParams) => {
    setAttributeParams(attributeParams);
  }, []);

  const handleClick = (id, data) => {
    console.log("handleClick", id, data);
    dispatch(luminaireActions.UpdateLuminaireList({
      ...state.LuminaireCfg, selectedResultLuminId: id,
      selectedResultName: data.name, selectedLuminaireIds: [id],
      selectedFolderIds: [data.parentId]
    }));

    // dispatch(user.UpdateUserCfg({ refreshLuminaireInfo: true }));
    setSelectedNode(id);
    //set selectedFolder ids here???
  }

  const getAllLowestChildrenFolders = () => {
    EdgeOrREST(null, 'GET_ALL_LOWEST_CHILDREN_FOLDER', getAllLowestChildrenFolder, props);
  }

  const getAllLowestChildrenFolder = (response) => {
    if (response) {
      setLowestGroups(response.data);
    }
  };

  const handleSortChange = (value) => {
    setSort(value);
    state.user.sortBy = value;
    dispatch(user.UpdateUserCfg(state.user));
  }

  const sortedGroups = (groups, count) => {
    // console.log("sortedGroups", groups, sort);
    switch (sort) {
      case 0: // Alphabetical (A-Z)
        return groups?.slice()
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(group => {
            // console.log("case 0", sort, group);
            return renderTree(group, count++);
          });
      case 1: // Reverse Alphabetical (Z-A)
        return groups?.slice()
          .sort((a, b) => b.name.localeCompare(a.name))
          .map(group => {
            console.log("case 1", sort, group);
            return renderTree(group, count++);
          });

      case 2: // Creation Date Ascending (Oldest First)
        return groups?.slice()
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          .map(group => {
            console.log("case 2", sort, group);
            return renderTree(group, count++);
          });

      case 3: // Creation Date Descending (Newest First)
        return groups?.slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .map(group => {
            console.log("case 3", sort, group);
            return renderTree(group, count++);
          });

      default:
        console.error('Invalid sort option');
        return [];
    }
  };


  const handleRefreshTree = () => {
    setIsRefresh(true)
    resetGotChildren();
    setSelectedNode(null);

    console.log("force refresh group");
    props.forceUpdate();
    setTimeout(() => { setIsRefresh(false) }, 750);
  }

  const onGroupFilterChange = (e, id) => {
    if (e.nativeEvent.inputType == "insertText") {
      var currText = groupFilter.get(id) == undefined ? "" : groupFilter.get(id);
      setGroupFilter(new Map(groupFilter.set(id, currText + e.nativeEvent.data)));
    } else if (e.nativeEvent.inputType == "deleteContentBackward") {
      var currText = groupFilter.get(id) == undefined ? "" : groupFilter.get(id);
      setGroupFilter(new Map(groupFilter.set(id, currText.slice(0, -1))));
    } else if (e.nativeEvent.inputType == "deleteWordBackward") {
      setGroupFilter(new Map(groupFilter.set(id, "")));
    }
  };


  const handleSingleCheck = (lumId, checked) => {
    setSelectedToRemove(prev =>
      checked
        ? [...prev, lumId]
        : prev.filter(id => id !== lumId)
    );
  };

  const handleSelectStart = (lumId, checked) => {
    const action = checked ? 'uncheck' : 'check';
    setIsSelecting(true);
    setSelectAction(action);
    setSelectedToRemove(prev =>
      action === 'check'
        ? [...prev, lumId]
        : prev.filter(id => id !== lumId)
    );
  };

  const handleSelectHover = (lumId) => {
    if (isSelecting && selectAction) {
      setSelectedToRemove(prev =>
        selectAction === 'check'
          ? prev.includes(lumId) ? prev : [...prev, lumId]
          : prev.filter(id => id !== lumId)
      );
    }
  };

  const handleSelectEnd = () => {
    setIsSelecting(false);
    setSelectAction(null);
  };

  useEffect(() => {
    const handleMouseUp = () => {
      setIsSelecting(false);
      setSelectAction(null);
    };
    window.addEventListener('mouseup', handleMouseUp);
    return () => window.removeEventListener('mouseup', handleMouseUp);
  }, []);

  const renderTree = (item, count) => {
    // console.log("renderTree for item", item, count);

    // if (item?.luminaires) {
    //   console.log("renderTree for item with luminaires", item.id, item.luminaires.length, state.LuminaireCfg.selectedFolderIds, state);
    //   if (state.LuminaireCfg.selectedFolderIds[0] == item.id) {
    //     console.log("renderTree for item with luminaires, selectedFolderIds", once, state.LuminaireCfg.selectedFolderIds[0], item.id);
    //     if (!once) {
    //       setOnce(true)
    //       dispatch(luminaireActions.UpdateLuminaireList({ groupLength: item?.luminaires.length }));
    //     }
    //   }
    // }

    // console.log("renderTree for item", item.id, {
    //   luminaires: item.luminaires,
    //   isLoading: loadingGroups,
    //   groups: props.groups,
    // });

    return (
      <Paper className={classes.paper}>
        <Group forceUpdate={onChangeGroup} name={item?.name} description={item?.description} type="group" nodeId={item.id} labelText={item.name /*+ " - ID: " + item.id*/} labelIcon={FolderIcon}
          color="#1a73e8" bgColor="#e8f0fe" labelInfo={DeleteIcon} removeLuminaire={RemoveIcon} onRemoveConfirmed={onRemoveConfirm} editGroupAttributes={EditIcon} parentGroupId={item.parentId}
          resetGotChildren={resetGotChildren} isLowest={lowestGroups.some(group => group.id === item.id)} lowestGroups={lowestGroups} isPublish={item.isPublish} currentGroup={item}
          setExpanded={setExpanded} expanded={expanded} setGotChildren={setGotChildren} gotChildren={gotChildren} useTreeItemStyles={useTreeItemStyles}
        >
          <TreeView
            defaultCollapseIcon={<ArrowDropDownIcon />}
            defaultExpandIcon={<ArrowRightIcon />}
            defaultEndIcon={<div style={{ width: 24 }} />}
            expanded={expanded}
            onNodeToggle={handleNodeToggle}
            style={{ paddingLeft: '10px' }}
          >
            {item?.luminaires ? <></> : <div style={{ textAlign: "center" }}>
              <Button variant="text" id={item.id} color="inherit" onClick={() => handleOpen(item.id)} >
                <AddIcon style={{ marginTop: 10, fontSize: '15pt' }} />
                <Typography variant="body2" className={classes.labelText}>
                  {"Add Group"}
                </Typography>
              </Button>
              <TextField
                onChange={(e) => onGroupFilterChange(e, item.id)}
                value={groupFilter.get(item.id)}
                label={<Typography >Group Filter</Typography>}
                style={{ width: 200, marginLeft: 10, marginBottom: 10, fontSize: '15pt' }}
              />
            </div>}


            {/* This is for subgroups only, if the item has groups, we will render them here. */}
            {loadingGroups[item.id] ? (
              <Loading type={"circular"} />
            ) :
              (() => {
                const filteredGroups = item.groups?.slice().filter(group =>
                  group?.name.toLowerCase().includes(groupFilter.get(item.id)?.toLowerCase() || "")
                );

                return sortedGroups(filteredGroups, count);
              })()
              // console.log("sortedGroups ", item.groups),
              // sortedGroups(item.groups?.slice(), count)
            }

            {/* This is for luminaires only, if the item has luminaires, we will render them here. */}
            {!loadingGroups[item.id] ?
              item?.luminaires?.map((luminaire) => {
                return (
                  <Luminaire
                    isCopy={luminaire.isCopy}
                    parentId={luminaire.parentId}
                    nodeId={luminaire.id}
                    luminaireId={luminaire.luminaireId}
                    // onSelectLuminaire={onSelectLuminaire}
                    key={luminaire.id}
                    color="#1a73e8"
                    bgColor="#e8f0fe"
                    labelText={luminaire.name}
                    labelIcon={DescriptionIcon}
                    forceUpdate={onChangeGroup}
                    resetGotChildren={resetGotChildren}
                    selectedNode={selectedNode}
                    onLabelClick={() => { handleClick(luminaire.luminaireId, luminaire) }}
                    description={luminaire?.description}
                    useTreeItemStyles={useTreeItemStyles}
                    checked={selectedToRemove.includes(luminaire.id)}
                    onSingleCheck={handleSingleCheck}
                    onSelectStart={() => handleSelectStart(luminaire.id, selectedToRemove.includes(luminaire.id))}
                    onSelectHover={() => handleSelectHover(luminaire.id)}
                    onSelectEnd={handleSelectEnd}
                  />
                );
              }) : <></>}
          </TreeView>
        </Group>
      </Paper>
    );
  }

  return (
    <>
      <Dialog
        className='manageStep8'
        open={open}
        onClose={handleDialogClose}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle>Create Group</DialogTitle>
        <DialogContent >
          <DialogContentText>
            Please enter the Name, Description and choose the Photometric Attributes.
          </DialogContentText>
          <TextField
            error={addGroupError}
            autoFocus
            margin="dense"
            label="Enter Name"
            id="standard-name"
            type="text"
            fullWidth
            variant="standard"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Enter Description"
            type="text"
            fullWidth
            id="standard-name"
            defaultValue=""
            value={groupDescription}
            onChange={(e) => setGroupDescription(e.target.value)}
            inputProps={{ maxLength: 250 }}
          />
          <Paper square>
            <Tabs
              value={addTap}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              onChange={(e, value) => setAddTap(value)}
            >
              <Tab index={0} name="lighting" label="street lighting"  {...a11yProps(0)} value={0} />
              {/* <Tab index={1} label="Spektd" {...a11yProps(1)} value={1} /> */}
            </Tabs>
          </Paper>
          <TabPanel value={addTap} index={0}>
            <PhotometricAttributeStreetlightSelector handleAttributeParams={handleAttributeParams} parentGroupId={parentGroupId} />
          </TabPanel>
          {/* <TabPanel value={addTap} index={1}>
            <PhotometricAttributeSelector handleAttributeParams={handleAttributeParams} parentGroupId={parentGroupId} />
          </TabPanel> */}
        </DialogContent>
        <div style={{ textAlign: "right", margin: 10 }}>
          <Button disabled={!groupName || groupName.length <= 0} variant="contained" color="primary" onClick={createGroup}>
            Create Group
          </Button>
        </div>
      </Dialog>

      {/* Message during the batch upload of files */}
      <Dialog
        open={openRepeat}
        onClose={() => setOpenRepeat(false)}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle>Continue Adding Files</DialogTitle>
        <DialogContent >
          <DialogContentText>
            You have {postArr.length} files left to upload. Would you like to continue?
            Auto continue in {counter} second(s).
          </DialogContentText>
        </DialogContent>
        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'flex-end', marginRight: '10px', marginBottom: '10px' }}>
          <Button onClick={() => { setOpenRepeat(false); setIsLoading(""); setProcessComplete(true); }}>
            Exit
          </Button>
          <Button variant="contained" color="primary" onClick={() => handleRepeatUpload()}>
            Continue
          </Button>
        </div>
      </Dialog>
      {/* End of message */}

      {checkForAdminPriv()}
      <TextField
        value={sort}
        onChange={(e) => handleSortChange(e.target.value)}
        select
        label="Sort By"
        variant="outlined"
        style={{ width: 120, marginLeft: 10, alignSelf: 'flex-end' }}
      >
        {sortBy.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField onChange={(e) => onGroupFilterChange(e, 0)} value={groupFilter.get(0)} label={<Typography >Group Filter</Typography>} style={{ width: 200, marginLeft: 10 }}
      />
      <Button style={{ position: "absolute", right: "3%" }} variant='outlined' color="primary" onClick={() => handleRefreshTree()}>Refresh</Button>
      <TreeView
        className={classes.root}
        defaultCollapseIcon={<ArrowDropDownIcon />}
        defaultExpandIcon={<ArrowRightIcon />}
        defaultEndIcon={<div style={{ width: 24 }} />}
        expanded={expanded}
        onNodeToggle={handleNodeToggle}
      >
        {isRefresh ? (
          <Loading type={"circular"} height={700} />
        ) : (
          isLoading === "files"
            ? progress > 0
              ? <Loading type={"linear"} text={"Adding Files..."} height={200} value={progress} />
              : <Loading type={"circular"} text={"Adding Files..."} height={200} />
            : isLoading === "folders"
              ? <Loading type={"circular"} text={"Adding Folders..."} height={200} />
              : <div style={{ textAlign: "center" }}>
                <Button variant="text" color="inherit" onClick={() => handleOpen(0)} >
                  <AddIcon style={{ fontSize: '15pt' }} />
                  <Typography variant="body2" className={classes.labelText}>
                    {"Add Group"}
                  </Typography>
                </Button>
                {/* Folder Selection begins here */}
                <DirectoryInput />
              </div>)}

        {!isRefresh ? (() => {
          const filteredGroups = props.groups?.slice().filter(item =>
            item.name.toLowerCase().includes(groupFilter.get(0).toLowerCase())
          );
          // console.log("Filtered groups count:", filteredGroups.length, filteredGroups);
          console.log("base sortedGroups", filteredGroups, sort);
          return sortedGroups(filteredGroups, 0);
        })() : <></>}


      </TreeView>
      <Notification onClose={handleClose} open={snack.open} severity={snack.severity} message={snack.message}></Notification>
    </>
  );
}
